import Price from '~/utils/Price';
import { CalculationPrice } from '~/Api/User/ProductGroup/LtMaxPrice/CalculationPrice';
import { Error, ErrorCode } from '~/Api/User/ProductGroup/LtMaxPrice/Error';
import { ReferencedProduct } from '~/Api/User/ProductGroup/LtMaxPrice/ReferencedProduct';

export class FinalCalculation {
	constructor(
		public emptyResultReason: Error[],
		public gesvisPrice: CalculationPrice | null,
		public priceDropPercents: number | null,
		public referencedProduct: ReferencedProduct | null
	) {}

	hasMissingProductSettings(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.requiredProductSettingsMissing) !== undefined
		);
	}

	requiresMinOneReferenceProductErrorCode(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.requiresMinOneReferenceProduct) !== undefined
		);
	}

	findMaxOneReferenceProductError(): Error | null {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.requiresMaxOneReferenceProduct) ?? null;
	}

	isMissingReferenceSettings(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.requiresReferenceSettings) !== undefined;
	}

	isIllegalProductPriceTypeSelected(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.illegalPriceTypeSelected) !== undefined;
	}
}
